'use strict';

module.exports = '3.35.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 268
// module chunks = 35783957827783 114276838955818